var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell-quiz"},[_c('AppHiddenFields'),_c('AppRouterViewContainer',[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"},on:{"after-enter":_vm.$_stickyCTA_afterEnter,"before-leave":_vm.$_stickyCTA_beforeLeave}},[_c('router-view',{attrs:{"theme":_vm.theme}})],1)],1),_c('AppSimpleFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }